module.exports = __webpack_public_path__ + "img/node-js.a83aa6be.png";